import { Typography as DSTypography } from '@naturacosmeticos/natds-react'
import styled from 'styled-components'

export const StyledTypography = styled(DSTypography)`
  p {
    color: ${(props) => props.theme.color.primaryDarkest};
    margin: 0;
  }
`
